import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/48_card_back_yacht/48_card_back_yacht"
 * Contains 1 texture(s)
 */
export class CardsBacks48CardBackYachtAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/48_card_back_yacht/48_card_back_yacht';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '48_yacht.png'
    ] as const;
}
